import Overlay from './src/overlay'

export const ElOverlay = Overlay
export default ElOverlay

export * from './src/overlay'
